export default "__VITE_ASSET__CP_mHNaw__"